import React from "react";
import logo from "./apple-touch-icon-72-png-data.png";
import "./LoadingWrapper.css";

export default function Loading({loading}) {
  return (
    <div>
        {loading?(
            <div className="loading-container">
            <div className="loading-logo-wrapper">
                <img src={logo} alt="logo" className="loading-logo" />
                <div className="loading-ring"></div>
            </div>
            </div>
        ):<div></div>}
    </div>
  );
}
